// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  parseNumber,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const WITHUS_FIELD_ALIASES = {
  hospitalName: ['병의원명'],
  drugCode: ['청구코드'],
  drugName: ['제품명'],
  unitPrice: ['약가'],
  quantity: ['당월수량'],
  prescriptionAmount: ['당월금액'],
  feeRate: ['%'],
  additionalFeeRate: ['추가%'],
  settlementAmount: ['수수료'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '거래처명',
  '처방월',
  '병의원코드',
  '병의원명',
  '청구코드',
  '제품명',
  '약가',
  '당월수량',
  '당월금액',
  '%',
  '추가%',
  '프로모션',
  '프로모션2',
  '수수료',
  '비고',
];

function isWithusProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const withusPharmTemplate = {
  id: 'withus-pharm',
  name: '위더스제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isWithusProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isWithusProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(WITHUS_FIELD_ALIASES),
    );
    const extractedRows = [];
    const detectedPharmaceuticalCompany = '위더스제약';

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugCode = cleanText(row[columnMap.drugCode]);
      if (!drugCode) {
        return;
      }

      const feeRateBase = parseNumber(row[columnMap.feeRate]) || 0;
      const feeRateAdditional =
        parseNumber(row[columnMap.additionalFeeRate]) || 0;

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        customerName: row[columnMap.hospitalName],
        drugCode,
        drugName: row[columnMap.drugName],
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: feeRateBase + feeRateAdditional,
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default withusPharmTemplate;
